import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import constants from '../ndbk-constants'
import {
    Dialog
} from "@blueprintjs/core";

class Footer extends React.Component {
    render() {
        return (
            <div className="row">
                <div className="col-lg-12 footer">
                    <div>
                        <h1 className="landing-logo small"><span>node</span>book</h1>
                    </div>
                    <div>
                        <a target="_blank" href="https://twitter.com/nodebook_io">Twitter</a> <strong>&#183;</strong> <a target="_blank" href="https://angel.co/nodebook">AngelList</a> <strong>&#183;</strong> <a target="_blank" href="mailto:info@nodebook.io">info@nodebook.io</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer.js